<template>
   <label class="question" :class="isChecked ? 'selected' : ''">
    <input class="checkbox" type="checkbox" :checked="isChecked" :value="value" @input="$emit('change', $event.target.checked )" />
    <inline-svg class="radiobutton" :src="require(`@/assets/img/radio.svg`)" v-if="!isChecked" alt="radio-icon"/>
    <inline-svg class="radiobutton" :src="require(`@/assets/img/checked.svg`)"  v-else alt="checked-icon"/>
    <p class="no-margin">{{label}}</p>
  </label>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
export default {
  components: {
    InlineSvg,
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    "label": { type: String, default: "", required:true },
    "modelValue": { default: "" },
    "value": { type: String, default: undefined }
  },
  computed: {
    isChecked() {
      return this.modelValue == true
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  display: inline-flex;
  position: relative;
  padding: 14px 18px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  width: 100%;
  -webkit-box-shadow: inset 0px 0px 0px 1px var(--gray-dark);
  -moz-box-shadow: inset 0px 0px 0px 1px var(--gray-dark);
  box-shadow: inset 0px 0px 0px 1px var(--gray-dark);
  align-items: center;
  border-radius: 4px;
  &.selected{
    -webkit-box-shadow: inset 0px 0px 0px 2px var(--pink);
  -moz-box-shadow: inset 0px 0px 0px 2px var(--pink);
  box-shadow: inset 0px 0px 0px 2px var(--pink);
  }
  p{
    margin-bottom: 0;
  }
  &.force-small{
    p{
      font-size: 14px !important;
    }
  }
}
/* Hide the browser's default radio button */
.question input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

label{
  display: block;
}

.radiobutton{
  margin-right: 14px;
}
</style>